<div class="results">
  <h2>Models</h2>

  @if (error()) {
    <p class="state state-error">{{ error() }}</p>
  } @else if (loading()) {
    <p class="state">Loading models…</p>
  } @else if (!ready()) {
    <p class="state state-muted">Select a make, year, and vehicle type to see models.</p>
  } @else if (models().length === 0) {
    <p class="state state-muted">No models found for this make, year, and vehicle type. Try a different year.</p>
  } @else {
    <cdk-virtual-scroll-viewport [itemSize]="rowHeight" class="model-viewport" role="list">
      <div
        *cdkVirtualFor="let row of rows(); trackBy: trackRow"
        class="model-row"
        [style.grid-template-columns]="gridTemplateColumns()">
        @for (model of row.models; track model.id) {
          <div class="model-card" role="listitem">{{ model.name }}</div>
        }
      </div>
    </cdk-virtual-scroll-viewport>
  }
</div>
